import React from 'react'
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText'
import LinkStyle from 'src/utils/LinkStyle'

const ThreeColumns = ({blok}) => {

  return (
        <SbEditable content={blok} key={blok._uid}>
            <div>
                <div className="my-12 bg-white">
                    <div className="max-w-xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                        <dl className="space-y-1 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-8">
                            {blok.items.map((item, index) => (
                                <div key={index}>
                                    {item.image_only ? ''
                                    :
                                    <div className={`${!item.title ? 'h-0 lg:h-5 mb-2' : 'h-5 mb-2'}`}>
                                        {blok.content_type === "magazine" ? 
                                        ( <h3 className="font-insights-display text-lg leading-5 font-semibold" style={{ color: blok.primary_colour }}>{item.title}</h3>)
                                        :
                                        ( <h3 className="mt-5 mb-2" style={{ color: blok.text_colour }}>{item.title}</h3>)}
                                    </div>
                                    }
                                    <div className={`prose prose-${blok._uid} text-sm mb-4 ${blok.content_type === 'magazine' ? "font-insights-body" : "font-body"}`}>
                                        <RichText>{item.content}</RichText>
                                    </div>
                                </div>
                            ))}
                        </dl>
                    </div>
                </div>
            </div>
            <LinkStyle {...blok}/>
        </SbEditable>
    )
}

export default ThreeColumns
